import { Link as RouterLink } from 'react-router-dom';
import { BoxProps } from '@mui/material';
import cn from 'classnames';

import { useCollapseDrawer } from 'hooks/useCollapseDrawer';

import s from './Logo.module.scss';

const Icon = () => {
  const { opened, hovered } = useCollapseDrawer();

  return (
    <svg
      className={cn(s.logo, { [s.closed]: !opened, [s.hovered]: !opened && hovered })}
      width="105"
      height="16"
      viewBox="0 0 105 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M98.0887 15.7092L96.8866 13.2221H88.0784L86.897 15.7092H80.9281L88.555 0.28949H96.4721L104.534 15.7092H98.0887ZM89.8815 9.36721H95.0006L92.41 4.06151L89.8815 9.36721Z"
        fill="black"
        fillOpacity="0.87"
      />
      <path
        d="M81.6744 10.7564C81.6744 13.3678 80.2237 15.9999 72.12 15.9999H70.234C61.7159 15.9999 60.8247 12.5388 60.8247 10.5284V10.3212H67.291C67.3532 11.1502 67.7884 12.4974 71.1459 12.4974H71.3325C74.6278 12.4974 75.1045 11.7927 75.1045 11.0466V11.0259C75.1045 10.259 74.7314 9.72016 71.4776 9.63725L68.6175 9.55435C62.6485 9.36782 61.0527 7.31601 61.0527 4.91187V4.72534C61.0527 2.21757 62.7522 0.0206757 69.9231 0.0206757H71.7677C79.3947 0.0206757 81.1356 2.44555 81.1356 4.89114V5.05695H74.7314C74.6693 4.49736 74.3377 3.41964 71.0009 3.41964H70.7936C67.7055 3.41964 67.3947 3.9585 67.3947 4.55953V4.58026C67.3947 5.20202 67.8506 5.72016 70.7522 5.76161L73.5294 5.82378C79.3947 5.96886 81.6744 7.37819 81.6744 10.4663V10.7564Z"
        fill="black"
        fillOpacity="0.87"
      />
      <path
        d="M43.575 0.28949H49.461V11.2947H60.1553V15.7092H43.575V0.28949Z"
        fill="black"
        fillOpacity="0.87"
      />
      <path
        d="M30.0649 -3.05176e-05H30.9976C40.9457 -3.05176e-05 42.2307 4.72536 42.2307 7.64764V8.2694C42.2307 11.1502 40.9665 16 30.9976 16H30.0649C20.0753 16 18.811 11.1502 18.811 8.2694V7.64764C18.811 4.72536 20.0753 -3.05176e-05 30.0649 -3.05176e-05ZM36.1375 7.79272C36.1375 6.15541 35.1012 4.14505 30.5209 4.14505C25.8784 4.14505 24.9043 6.15541 24.9043 7.79272V8.04142C24.9043 9.658 25.9613 11.8342 30.5209 11.8342C35.0805 11.8342 36.1375 9.72018 36.1375 8.08287V7.79272Z"
        fill="black"
        fillOpacity="0.87"
      />
      <path
        d="M13.4093 15.7092L5.88601 8.80762V15.7092H0V0.28949H5.88601V6.38275L13.4715 0.28949H20.7876L11.8135 7.29467L21.0777 15.7092H13.4093Z"
        fill="black"
        fillOpacity="0.87"
      />
    </svg>
  );
};

interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

export const Logo = ({ disabledLink = false }: LogoProps) => (
  <>
    {disabledLink ? (
      <Icon />
    ) : (
      <RouterLink to="/" style={{ height: '17px' }}>
        <Icon />
      </RouterLink>
    )}
  </>
);
